module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-btn-audio.a3c5457f.png";